'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

import { InfoImage, InfoText } from './Content';

const CONTAINER_ANIMATION = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1,
    },
  },
};

const ITEM_ANIMATION = {
  hidden: { opacity: 0, y: 15 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

const EMPHASIS_ANIMATION = {
  initial: { backgroundSize: '0% 100%' },
  animate: {
    backgroundSize: '100% 100%',
    transition: {
      duration: 0.6,
      ease: 'easeOut',
      delay: 0.3,
    },
  },
};

export const Info = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  return (
    <motion.section
      ref={ref}
      variants={CONTAINER_ANIMATION}
      initial="hidden"
      animate={isInView ? 'visible' : 'hidden'}
      className="flex flex-col items-center gap-16 px-32 py-60 text-center font-400 text-Gray-900 typo-body3"
      aria-labelledby="info-heading"
    >
      <motion.div variants={ITEM_ANIMATION}>
        <InfoImage />
      </motion.div>
      <motion.div variants={ITEM_ANIMATION} className="pt-16">
        <InfoText>
          고향사랑기부제는 지방소멸 위기 대응과
          <br />
          <motion.span
            className="inline-block font-700"
            style={{
              background:
                'linear-gradient(to right, #FFF4BE 0%, #FFF4BE 100%) no-repeat',
              backgroundPosition: '0 80%',
              backgroundSize: '0% 40%',
            }}
            variants={EMPHASIS_ANIMATION}
            initial="initial"
            animate={isInView ? 'animate' : 'initial'}
          >
            지역 균형발전을 위해 도입된
          </motion.span>
          &nbsp;국가정책이에요.
        </InfoText>
      </motion.div>
      <motion.p variants={ITEM_ANIMATION}>
        자신의 주소지를 제외한 다른 지자체에 기부하면
        <br />
        해당 지역 복지·문화·청년정책 등에 활용돼요.
      </motion.p>
      <motion.p variants={ITEM_ANIMATION}>
        기부자는{' '}
        <motion.span
          className="inline-block font-700"
          style={{
            background:
              'linear-gradient(to right, #FFF4BE 0%, #FFF4BE 100%) no-repeat',
            backgroundPosition: '0 80%',
            backgroundSize: '0% 40%',
          }}
          variants={EMPHASIS_ANIMATION}
          initial="initial"
          animate={isInView ? 'animate' : 'initial'}
        >
          100% 세액공제 혜택
        </motion.span>
        과 함께
        <br />
        기부금의{' '}
        <motion.span
          className="inline-block font-700"
          style={{
            background:
              'linear-gradient(to right, #FFF4BE 0%, #FFF4BE 100%) no-repeat',
            backgroundPosition: '0 80%',
            backgroundSize: '0% 40%',
          }}
          variants={EMPHASIS_ANIMATION}
          initial="initial"
          animate={isInView ? 'animate' : 'initial'}
        >
          30% 만큼 답례품
        </motion.span>
        을 받을 수 있어요.
      </motion.p>
    </motion.section>
  );
};
